





















import { Component, Vue } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import CreateContactDialog from '@/components/crm/shared/CreateContactDialog.vue';
import contactsRepos from '@/services/contactsRepository';
import '@/types';

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxStateStoring,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import notificationService from '@/services/notificationService';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxSearchPanel,
    CreateContactDialog,
    cCard,
    cDatagrid,
  },
})
export default class ContactsOverview extends Vue {
  loading: boolean = false;
  items: any[] = [];
  selectedContact: ICompany | null = null;

  datasource: any = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        const searchText = (this.$refs.grid as any).$refs.contactstable.instance.option('searchPanel.text');
        if (searchText) {
          loadOptions.filter = null;
          loadOptions.searchValue = searchText;
        }
        const result = await contactsRepos.lookup(loadOptions);
        const contacts: any = result.data;
        return {
          data: contacts.data,
          totalCount: contacts.totalCount,
        };
      },
      byKey: async (val: any) => {
          return contactsRepos.getSingle(val).then((result: any) => {
              return result.data.data;
          });
      },
    }),
    paginate: true,
  });

  addContact(id?: string) {
    (this.$refs.CreateContactDialog as CreateContactDialog).show = true;
  }

  showContactDetails(e: any) {
    if (e.column && e.column.type !== 'buttons') {
      this.goToDetails(e.data);
    }
  }

  deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await contactsRepos.delete(e.data);
        ((this.$refs.grid as cDatagrid).$refs.contactstable as any).instance.refresh();
        notificationService.saved();
        resolve(true);
      } catch (err) {
        notificationService.showAxiosError(err);
      }
      resolve(true);
    });
  }

  goToDetails(contact: ICompany | IContact) {
    switch (contact.type) {
        case 'Contact':
          this.$router.push({ path: `/contacts/${contact.id}` });
          break;
        case 'Company':
          this.$router.push({ path: `/companies/${contact.id}` });
          break;
        case 'Subcontractor':
          this.$router.push({ path: `/subcontractors/${contact.id}` });
          break;
      }
    }

  get columns() {
    return [
      {
        dataField: 'displayName',
        caption: this.$t('objects.contacts.Fields.DisplayName'),
        cellTemplate: (cellElement: any, cellInfo: any) => {
          let icon = '';
          switch (cellInfo.data.type) {
            case 'Subcontractor':
              icon = 'fa-hard-hat';
              break;
          case 'Company':
              icon = 'fa-building';
              break;
          case 'Contact':
              icon = 'fa-user';
              break;
          }
          return $(cellElement).append(`<i class='fas ${icon}'></i> ${cellInfo.data.displayName}`);
        },
      },
      {
        dataField: 'phone',
        caption: this.$t('objects.contacts.Fields.Phone'),
      },
      {
        dataField: 'email',
        caption: this.$t('objects.contacts.Fields.Email'),
      },
      {
        dataField: 'type',
        caption: this.$t('objects.contacts.Fields.Type'),
        lookup: {
          dataSource: [
            {value: 'Subcontractor', text: 'Onderaannemer'},
            {value: 'Company', text: 'Bedrijf'},
            {value: 'Contact', text: 'Contact'},
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        type: 'buttons',
        buttons: [
          'delete',
        ],
      },
    ];
  }
}
